'use strict';exports.__esModule = true;exports.getLocalization = exports.loadLanguageData = undefined;exports.






















setLocalization = setLocalization;var _reduxPagan = require('redux-pagan');var _constants = require('../constants');var loadLanguageData = exports.loadLanguageData = function loadLanguageData(locale) {/* eslint-disable import/no-dynamic-require */var contentObj = require('../translations/' + locale + '.json');contentObj.privacy = require('../translations/privacy/' + locale + '.json');contentObj.terms = require('../translations/terms/' + locale + '.json');contentObj.about = require('../translations/about/' + locale + '.json');contentObj.citiesDescription = require('../translations/citiesDescription/' + locale + '.json');contentObj.projectsDescription = require('../translations/projectsDescription/' + locale + '.json'); /* eslint-enable import/no-dynamic-require */return contentObj;};var getLocalization = exports.getLocalization = function getLocalization(lang) {var idx = _constants.language.supportedLanguages.indexOf(lang);if (idx === -1) {return _constants.language.default;}return _constants.language.supportedLanguages[idx];};function setLocalization(lang) {
  var localization = getLocalization(lang);
  var langData = loadLanguageData(localization);
  return (0, _reduxPagan.loadLang)(localization, langData);
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/localization.js
// module id = 3006
// module chunks = 0